<template>
  <div class="content-width py-4" v-if="isAdmin">
    <b-button
      squared
      variant="cms_main"
      type="button"
      v-b-modal.modalVendorModal
      ><b-icon icon="plus-circle" class="mr-2"></b-icon>新增商品</b-button
    >
    <b-alert class="mt-4" variant="warning" show
      ><b-icon icon="exclamation-diamond-fill" class="mr-2"></b-icon
      >注意：停用商品後即可刪除商品</b-alert
    >
    <div class="pt-3">
      <b-table
        v-if="!isMobile"
        responsive
        striped
        hover
        bordered
        head-variant="light"
        :items="selectFilterItem"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的商品"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(price)="data">
          <div class="text-right">{{ toThousands(data.item.price) }}</div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="copy(data.item.id)"
              ><b-icon icon="stickies" class="mr-2"></b-icon
              >複製</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>

      <b-table
        v-else
        striped
        bordered
        head-variant="light"
        :items="selectFilterItem"
        :fields="fields_mobile"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        empty-text="目前尚無資料"
        empty-filtered-text="沒有找到符合的商品"
        show-empty
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:emptyfiltered="{ emptyFilteredText }">
          <div class="text-center">{{ emptyFilteredText }}</div>
        </template>
        <template v-slot:cell(show_details)="row">
          <div class="btn-only-icon">
            <b-button
              @click="toggleDetails(row)"
              class="btn-link border-0"
              variant="outline-light"
              size="sm"
            >
              <b-icon
                :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'"
                variant="dark"
              ></b-icon>
            </b-button>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="status-switch">
            <input
              type="checkbox"
              :id="'switch-' + data.index"
              v-model="data.item.status"
              @click="changeStatus('switch-' + data.index, data.item.id)"
            />
            <label :for="'switch-' + data.index"></label>
          </div>
        </template>
        <template v-slot:cell(active)="data">
          <b-dropdown
            right
            no-caret
            variant="link"
            boundary="viewport"
            class="btn-only-icon"
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
            </template>
            <b-dropdown-item href="#" @click="edit(data.item.id)"
              ><b-icon icon="pencil-square" class="mr-2"></b-icon
              >編輯</b-dropdown-item
            >
            <b-dropdown-item href="#" @click="copy(data.item.id)"
              ><b-icon icon="stickies" class="mr-2"></b-icon
              >複製</b-dropdown-item
            >
            <b-dropdown-divider v-if="!data.item.status"></b-dropdown-divider>
            <b-dropdown-item
              v-if="!data.item.status"
              href="#"
              @click="dele(data.item.id)"
              ><span class="text-danger"
                ><b-icon icon="trash" class="mr-2"></b-icon>刪除</span
              ></b-dropdown-item
            >
          </b-dropdown>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-3">
              <b-col sm="3"><b>編號</b></b-col>
              <b-col>{{ row.item.serial_no }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>定價</b></b-col>
              <b-col>{{ toThousands(row.item.price) }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>零件類型</b></b-col>
              <b-col>{{ row.item.part_name }}</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3"><b>介紹</b></b-col>
              <b-col v-html="row.item.description"></b-col>
            </b-row>
            <template v-for="iten in detailsData">
              <template v-if="iten.id == row.item.id">
                <b-row class="mb-3" :key="'images' + iten.id">
                  <b-col sm="3"><b>圖片</b></b-col>
                  <b-col v-if="iten.images.length">
                    <div class="row no-gutters">
                      <div
                        class="col-6 my-1 px-1"
                        v-for="image in iten.images"
                        :key="'image' + image.id"
                      >
                        <img
                          :src="getAllImgUrl(image.image_link)"
                          alt=""
                          class="img-fluid"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col v-else class="text-secondary">(此商品尚無圖片)</b-col>
                </b-row>
                <b-row class="mb-3" :key="'cars' + iten.id">
                  <b-col sm="3"><b>適用的車款</b></b-col>
                  <b-col v-if="iten.general_parts">全部適用</b-col>
                  <b-col v-else>
                    <table class="table mt-2">
                      <tbody>
                        <tr
                          v-for="car in iten.categories"
                          :key="'car' + car.id"
                        >
                          <td>
                            {{ getCategoryName([car.car_year_id])[0].name }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </template>
            </template>
            <b-row class="">
              <b-col class="text-center">
                <b-button
                  size="sm"
                  squared
                  variant="cms_main"
                  @click="toggleDetails(row)"
                  >收起詳細資訊</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>

      <div class="row align-items-center" v-if="totalRows">
        <div class="col-sm col-12 text-right text-sm-left">
          顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
          {{
            currentPage == 1
              ? totalRows > perPage
                ? perPage
                : totalRows
              : perPage * (currentPage - 1) + perPage > totalRows
              ? totalRows
              : perPage * (currentPage - 1) + perPage
          }}
          項結果，共 {{ totalRows }} 項
        </div>
        <div class="col-sm col-12">
          <b-pagination
            v-if="totalRows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            first-number
            last-number
            class="mb-sm-0 mb-3 mt-sm-0 mt-3 cms_main"
          ></b-pagination>
        </div>
      </div>
    </div>
    <b-modal
      id="modalVendorModal"
      size="lg"
      :title="modal_title"
      no-close-on-backdrop
      centered
      tall
      scrollable
      @ok="onSubmit"
      @show="showModal"
      @hidden="hiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="row">
          <div class="col-lg-6">
            <b-form-group
              label="名稱"
              label-for="productName"
              invalid-feedback="請填寫商品名稱"
              :state="state.name"
              class="required"
            >
              <b-form-input
                id="productName"
                class="rounded-0"
                v-model="form.name"
                type="text"
                required
                placeholder="商品名稱"
                :state="state.name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group
              label="編號"
              label-for="productSerialNo"
              invalid-feedback="請填寫商品編號"
              :state="state.serial_no"
              class="required"
            >
              <b-form-input
                id="productSerialNo"
                class="rounded-0"
                v-model="form.serial_no"
                type="text"
                required
                placeholder="商品編號"
                :state="state.serial_no"
                :readonly="isEdit"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group
              label="定價"
              label-for="productPrice"
              invalid-feedback="請填寫商品價格"
              :state="state.price"
              class="required"
            >
              <b-form-input
                id="productPrice"
                class="rounded-0"
                v-model="form.price"
                type="number"
                min="0"
                required
                placeholder="商品金額"
                :state="state.price"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group
              label="零件類型"
              label-for="productCategory"
              invalid-feedback="請選擇零件類型"
              :state="state.part_category_id"
              class="required"
            >
              <select
                id="productCategory"
                class="custom-select rounded-0"
                v-model="form.part_category_id"
                :class="{ 'is-invalid': state.part_category_id === false }"
              >
                <option value="" selected disabled>請選擇</option>
                <option v-for="val in tag_list" :key="val.id" :value="val.id">{{
                  val.name
                }}</option>
              </select>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group
              label="零件品牌"
              label-for="partsBrand"
              invalid-feedback="請選擇零件品牌"
              :state="state.part_brand_id"
              class="required"
            >
              <v-select
                label="name"
                :reduce="type => type.id"
                :options="sortBrandList"
                v-model="form.part_brand_id"
                placeholder="請選擇"
                class="vue-select"
                :class="{ 'is-invalid': state.part_brand_id !== null }"
              >
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes"
                    ><b-icon icon="chevron-down"></b-icon
                  ></span>
                </template>
              </v-select>
            </b-form-group>
            <b-form-group label="商品介紹">
              <quill-editor
                ref="quillEdit"
                v-model="form.description"
                :options="editorOption"
              />
              <ImagePreview
                @childMethod="getImageUrlInQuill"
                v-show="false"
                ref="quillEditImage"
                :token="token"
              ></ImagePreview>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <ImagePreview
              @childMethod="getImageUrl"
              :image="form.images"
              :multiple="true"
              :quantity="4"
              :token="token"
            ></ImagePreview>
          </div>
          <div class="col-12">
            <b-form-group
              label="選擇適用的車款"
              label-for="productCategory"
              invalid-feedback="請選擇車款"
              :state="state.car_year_id"
              :class="{ 'is-invalid': state.car_year_id === false }"
              class="set-car-model required"
            >
              <b-list-group-item class="general_parts variant-cms">
                <b-form-checkbox
                  v-model="form.general_parts"
                  :value="1"
                  :unchecked-value="0"
                  :state="state.car_year_id"
                >
                  全適用
                </b-form-checkbox>
              </b-list-group-item>
              <div v-if="form.general_parts == 0">
                <hr />
                <div class="mb-3" v-if="form.car_year_id.length">
                  已選擇{{ form.car_year_id.length }}款
                  <b-button
                    class="ml-2"
                    variant="outline-cms_main"
                    size="sm"
                    squared
                    @click="removeYearActive('all')"
                    >清除全部</b-button
                  >
                </div>
                <div class="mb-3">
                  <b-button
                    pill
                    size="sm"
                    v-for="item in categoryNameLisr"
                    :key="item.id"
                    class="px-2 m-1 category-tpye"
                    v-b-tooltip.hover
                    title="移除此項目"
                    @click="removeYearActive(item.id)"
                  >
                    {{ item.name }}
                    <b-icon icon="x" aria-hidden="true"></b-icon>
                  </b-button>
                </div>
                <div
                  v-if="isLayoutToLg && card_active > 1"
                  class="my-2"
                  @click="card_active = 1"
                >
                  <b-icon icon="chevron-left" variant="dark"></b-icon>
                  回上一步
                </div>
                <div class="row no-gutters">
                  <div
                    class="col-lg-6"
                    v-if="isLayoutToLg ? card_active == 1 : true"
                  >
                    <b-list-group class="rounded-0">
                      <template v-for="item in category_list">
                        <b-list-group-item
                          :key="item.id"
                          class="d-flex justify-content-between align-items-center"
                          @click="clickBrand(item.id, item.name)"
                          :active="item.id == brand_active.id"
                          v-if="showBrand(item.models)"
                        >
                          {{ item.name }}
                          <b-badge
                            v-if="chackoutCategoryActive[item.id].qty"
                            variant="cms_main"
                            pill
                            class="ml-auto mr-2"
                            >{{ chackoutCategoryActive[item.id].qty }}</b-badge
                          >
                          <b-icon-chevron-right></b-icon-chevron-right>
                        </b-list-group-item>
                      </template>
                    </b-list-group>
                  </div>
                  <div
                    class="col-lg-6 accordion"
                    v-if="isLayoutToLg ? card_active > 1 : true"
                  >
                    <b-card-group>
                      <b-card
                        no-body
                        header-tag="header"
                        class="rounded-0"
                        header-class="rounded-0"
                      >
                        <template #header v-if="brand_active.name">
                          <div class="variant-cms">
                            <b-form-checkbox
                              :id="'brand_' + brand_active.id"
                              v-model="
                                chackoutCategoryActive[brand_active.id].active
                              "
                              @change="checkedBrandActive(brand_active.id)"
                            >
                              {{ brand_active.name }}
                            </b-form-checkbox>
                          </div>
                        </template>
                        <b-list-group class="model_list">
                          <template v-for="item in getModelList">
                            <b-list-group-item
                              :key="item.id"
                              class=" rounded-0"
                              :active="item.id == brand_active.id"
                              v-if="item.years.length"
                            >
                              <div
                                class="d-flex justify-content-between align-items-center"
                                @click="clickModel(item.id)"
                              >
                                <div @click.stop class="variant-cms">
                                  <b-form-checkbox
                                    :id="'model' + item.id"
                                    v-model="
                                      chackoutCategoryActive[item.car_brand_id][
                                        item.id
                                      ].active
                                    "
                                    @change="
                                      checkedModelActive(
                                        item.car_brand_id,
                                        item.id
                                      )
                                    "
                                  >
                                    {{ item.name }}
                                  </b-form-checkbox>
                                </div>
                                <b-icon-chevron-down></b-icon-chevron-down>
                              </div>
                              <b-collapse
                                :id="'collapse-model' + item.id"
                                class="type_list"
                                accordion="accordion"
                              >
                                <b-list-group-item
                                  v-for="val in item.years"
                                  :key="val.id"
                                  class="d-flex justify-content-between align-items-center rounded-0 variant-cms"
                                >
                                  <b-form-checkbox
                                    :id="'type' + val.id"
                                    v-model="
                                      chackoutCategory[val.car_brand_id][
                                        val.car_model_id
                                      ].year
                                    "
                                    :value="val.id"
                                  >
                                    {{ val.publish_year }} (
                                    {{ getTypeName(val.type) }}
                                    {{ val.displacing }} C.C. )
                                  </b-form-checkbox>
                                </b-list-group-item>
                              </b-collapse>
                            </b-list-group-item>
                          </template>
                        </b-list-group>
                      </b-card>
                    </b-card-group>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <small class="text-danger" v-if="!formValidity"
          >*必填欄位未填寫，請檢查</small
        >
        <div class="w-100 d-flex justify-content-between">
          <b-button
            squared
            variant="outline-dark"
            type="button"
            @click="cancel()"
            >取消</b-button
          >
          <b-button squared variant="cms_main" type="submit" @click="ok()"
            >儲存</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">
.quill-editor {
  background-color: #fff;
  margin-top: 30px;
}
.ql-container {
  font-size: 16px;
}
.ql-snow {
  .ql-tooltip {
    z-index: 100;
  }
  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
  .ql-color-picker .ql-picker-label:last-child svg {
    margin-bottom: 4px;
  }
}
</style>
<style lang="scss" scoped>
.vue-select {
  &.is-invalid {
    & ::v-deep .vs__dropdown-toggle {
      border-color: #dc3545;
    }
  }
  & ::v-deep .vs__dropdown-toggle {
    border-radius: 0px;
    border-color: #ced4da;
    height: 38px;
  }
}
</style>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor, Quill } from "vue-quill-editor";
import { Swal, Toast } from "@/plugins/sweetalert2.js";
import ImagePreview from "@/components/ImagePreview.vue";
import { Product } from "@/assets/api/cms.js";
import { getPartBrand } from "@/assets/api.config.js";
import ImageResize from "quill-image-resize-module";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const fontSizeArr = [
  "8px",
  "9px",
  "10px",
  "12px",
  "14px",
  "16px",
  "20px",
  "24px",
  "32px",
  "42px",
  "54px",
  "68px",
  "84px",
  "98px"
];

const Size = Quill.import("attributors/style/size");
Size.whitelist = fontSizeArr;

Quill.register("modules/imageResize", ImageResize);
Quill.register(Size, true);

const toolOptions = [
  // 標題
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  // 字型大小
  [{ size: fontSizeArr }],
  // [{ size: ["small", false, "large", "huge"] }],
  // 加粗 斜體 下劃線 刪除線 字型顏色
  ["bold", "italic", "underline", "strike", { color: [] }],
  // 加粗 斜體 下劃線 刪除線
  ["blockquote", "code-block"],
  // 1、2 級標題
  // [{ header: 1 }, { header: 2 }],
  // 有序、無序列表
  [{ list: "ordered" }, { list: "bullet" }],
  // 上標/下標
  // [{ script: "sub" }, { script: "super" }],
  // 縮排
  [{ indent: "-1" }, { indent: "+1" }],
  // 文字方向
  // [{ direction: "rtl" }],
  //、字型背景顏色
  //[{ background: [] }],
  // 字型種類
  // [{ font: [] }],
  // 對齊方式
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  // 連結、圖片、影片
  ["link", "image"]
];

export default {
  name: "Product",
  props: [
    "search",
    "part_brand",
    "part_category",
    "card_type",
    "card_brand",
    "card_model",
    "card_year",
    "isMobile",
    "token",
    "isAdmin"
  ],
  components: { ImagePreview, quillEditor, vSelect },
  data() {
    return {
      imageOnerror: "/img/image_onerror.jpg",
      isLayoutToLg: false,
      currentPage: 1,
      edit_id: null,
      card_active: 1,
      fields: [
        {
          key: "serial_no",
          label: "編號",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "name",
          label: "名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "part_brand",
          label: "零件品牌",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "part_name",
          label: "零件類型",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "price",
          label: "定價",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      fields_mobile: [
        {
          key: "show_details",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        },
        {
          key: "name",
          label: "名稱",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "status",
          label: "狀態",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "active",
          label: "",
          tdClass: "align-middle",
          thStyle: "width:35px"
        }
      ],
      filter: null,
      filterOn: ["serial_no", "name"],
      selectFilter: {
        part_brand: null,
        part_category: null
      },
      form: {
        name: "",
        serial_no: "",
        price: "",
        description: "",
        car_year_id: [],
        part_category_id: "",
        part_brand_id: "",
        images: [],
        general_parts: 0
      },
      isEdit: false,
      isModalShow: false,
      items: null,
      modal_title: "新增商品",
      perPage: 10,
      state: {
        name: null,
        serial_no: null,
        price: null,
        car_year_id: null,
        part_category_id: null,
        part_brand_id: null
      },
      totalRows: null,
      tag_list: null,
      brands_list: null,
      category_list: null,
      brand_list: null,
      type_list: null,
      brand_active: {
        id: null,
        name: null
      },
      model_active: null,
      type_active: null,
      editorOption: {
        theme: "snow",
        modules: {
          imageResize: {
            displaySize: true
          },
          toolbar: {
            container: toolOptions,
            handlers: {
              image: () => {
                this.$refs.quillEditImage.$el
                  .querySelector(".custom-file-input")
                  .click();
              }
            }
          }
        }
      },
      chackoutCategory: {},
      chackoutCategoryActive: {},
      categoryNameLisr: [],
      detailsData: [],
      formValidity: true,
      filter_condition: {
        type: "",
        brand: "",
        model: "",
        year: ""
      }
    };
  },
  computed: {
    getModelList() {
      if (!this.brand_active.id) return;
      let list;
      this.category_list.forEach(val => {
        if (val.id === this.brand_active.id) {
          list = val.models;
        }
      });
      return list;
    },
    getYearList() {
      if (!this.model_active) return;
      let list;
      this.getModelList.forEach(val => {
        if (val.id === this.model_active) {
          list = val.years;
        }
      });
      return list;
    },
    selectFilterItem() {
      if (!this.items) return;
      return this.items.filter(val => {
        if (!this.selectFilter.part_brand && !this.selectFilter.part_category) {
          return true;
        }
        if (
          val.part_brand == this.selectFilter.part_brand &&
          !this.selectFilter.part_category
        ) {
          return true;
        }
        if (
          val.part_name == this.selectFilter.part_category &&
          !this.selectFilter.part_brand
        ) {
          return true;
        }
        if (
          val.part_brand == this.selectFilter.part_brand &&
          val.part_name == this.selectFilter.part_category
        ) {
          return true;
        }
        return false;
      });
    },
    sortBrandList() {
      const brandIDs_list = this.brands_list;
      if (!brandIDs_list) return;
      return brandIDs_list.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
    }
  },
  created() {
    this.perPage = process.env.VUE_APP_TABLE_ROW_LENGTH || 15;
    this.filter = this.search;

    this.selectFilter.part_brand = this.part_brand;
    this.selectFilter.part_category = this.part_category;

    this.getProduct();
    getPartBrand()
      .then(res => {
        if (res.status <= 201) {
          this.brands_list = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "零件品牌資料取得失敗",
            text: res.data.error
          });
        }
      })
      .catch(err => {
        console.error(err);
      });
    this.brands_list;
    Product.getTag(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.tag_list = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "零件分類資料取得失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Product.getCategory(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.category_list = res.data.data;
          let obj = {};
          let objActive = {};
          this.category_list.forEach(val => {
            obj[val.id] = {};

            objActive[val.id] = {};
            objActive[val.id].name = val.name;
            objActive[val.id].qty = 0;
            objActive[val.id].active = false;
            objActive[val.id].modelsId = [];
            objActive[val.id].yearsId = [];

            val.models.forEach(model => {
              objActive[val.id].modelsId.push(model.id);

              obj[val.id][model.id] = {};
              obj[val.id][model.id].year = [];

              objActive[val.id][model.id] = {};
              objActive[val.id][model.id].name = model.name;
              objActive[val.id][model.id].qty = 0;
              objActive[val.id][model.id].active = false;
              objActive[val.id][model.id].yearsId = [];

              model.years.forEach(years => {
                objActive[val.id].yearsId.push(years.id);
                objActive[val.id][model.id].yearsId.push(years.id);

                objActive[val.id][model.id][years.id] = {};
                objActive[val.id][model.id][years.id].name = `${
                  years.publish_year
                }(${this.getTypeName(years.type)}/${years.displacing}CC)`;
              });
            });
          });
          this.chackoutCategory = Object.assign({}, this.chackoutCategory, obj);
          this.chackoutCategoryActive = Object.assign(
            {},
            this.chackoutCategoryActive,
            objActive
          );
        } else {
          Toast.fire({
            icon: "error",
            title: "汽車品牌資料取得失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Product.getBrand(this.token)
      .then(res => {
        if (res.status <= 201) {
          this.brand_list = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "汽車品牌資料取得失敗",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  watch: {
    form: {
      handler: function() {
        if (this.isModalShow && this.isEdit) {
          this.checkFormState();
        }
      },
      deep: true
    },
    chackoutCategory: {
      handler: function() {
        this.checkedQty();
      },
      deep: true
    },
    selectFilterItem: {
      handler: function(newItem) {
        this.onFiltered(newItem);
      },
      deep: true
    }
  },
  methods: {
    showBrand(models) {
      if (!models.length) {
        return false;
      }
      let qty = 0;
      models.forEach(val => {
        if (val.years.length) {
          qty++;
        }
      });
      if (qty) {
        return true;
      }
      return false;
    },
    getProduct() {
      let config = Object.assign({}, this.token);
      config.params = {
        type: this.card_type,
        years_id: this.card_year,
        models_id: this.card_model,
        brand_id: this.card_brand
      };
      Product.get("", config)
        .then(res => {
          if (res.status <= 201) {
            this.items = res.data;
            this.totalRows = this.items.length;
          } else {
            Toast.fire({
              icon: "error",
              title: "商品資料取得失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getAllImgUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    imageError() {
      this.$nextTick(() => {
        var imgList = document.querySelectorAll("img");
        Array.prototype.forEach.call(imgList, item => {
          item.onerror = () => {
            item.src = this.imageOnerror;
          };
        });
      });
    },
    toggleDetails(row) {
      if (row.detailsShowing == undefined || row.detailsShowing) {
        row.toggleDetails();
        this.detailsData.forEach((item, index) => {
          if (item.id == row.item.id) {
            this.detailsData.splice(index, 1);
          }
        });
      } else {
        Product.get(row.item.id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.detailsData.push(res.data);
            } else {
              Toast.fire({
                icon: "error",
                title: "商品資料取得失敗",
                text: res.data.error
              });
            }
          })
          .catch(error => {
            console.error(error);
          });
        this.$nextTick(() => {
          row.toggleDetails();
        });
        this.imageError();
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },
    getImageUrlInQuill(data) {
      const range = this.$refs.quillEdit.quill.getSelection();
      this.$refs.quillEdit.quill.insertEmbed(range.index, "image", data);
    },
    getImageUrl(data) {
      this.form.images = data;
    },
    getCategoryName(yearList) {
      let categoryNameList = [];
      yearList.forEach(val => {
        this.category_list.forEach(brand => {
          brand.models.forEach(model => {
            model.years.forEach(year => {
              if (year.id == val) {
                categoryNameList.push({
                  id: val,
                  name: `${brand.name} ${model.name} 
                    ${year.publish_year} 
                    (${this.getTypeName(year.type)} / 
                    ${year.displacing}c.c.)`
                });
              }
            });
          });
        });
      });
      return categoryNameList;
    },
    clickBrand(id, name) {
      this.brand_active.id = id;
      this.brand_active.name = name;
      this.card_active = 2;
    },
    clickModel(id) {
      this.$root.$emit("bv::toggle::collapse", "collapse-model" + id);
      if (this.model_active) {
        this.model_active = null;
      } else {
        this.model_active = id;
      }
    },
    checkedBrandActive(brand_id) {
      this.$nextTick(function() {
        this.chackoutCategoryActive[brand_id].modelsId.forEach(modelsId => {
          if (this.chackoutCategoryActive[brand_id].active) {
            this.chackoutCategoryActive[brand_id][modelsId].active = true;
            this.chackoutCategory[brand_id][modelsId].year = Object.assign(
              [],
              this.chackoutCategoryActive[brand_id][modelsId].yearsId
            );
          } else {
            this.chackoutCategoryActive[brand_id][modelsId].active = false;
            this.chackoutCategory[brand_id][modelsId].year = [];
          }
        });
      });
    },
    checkedModelActive(brand_id, model_id) {
      this.$nextTick(function() {
        if (this.chackoutCategoryActive[brand_id][model_id].active) {
          this.chackoutCategory[brand_id][model_id].year = Object.assign(
            [],
            this.chackoutCategoryActive[brand_id][model_id].yearsId
          );
        } else {
          this.chackoutCategory[brand_id][model_id].year = [];
        }
      });
    },
    confirmQty() {
      this.$nextTick(function() {
        Object.keys(this.chackoutCategoryActive).forEach(key => {
          this.chackoutCategoryActive[key].qty ==
          this.chackoutCategoryActive[key].yearsId.length
            ? (this.chackoutCategoryActive[key].active = true)
            : (this.chackoutCategoryActive[key].active = false);
          Object.keys(this.chackoutCategoryActive[key]).forEach(val => {
            if (
              val != "qty" &&
              val != "active" &&
              val != "name" &&
              val != "modelsId" &&
              val != "yearsId"
            ) {
              this.chackoutCategoryActive[key][val].qty ==
              this.chackoutCategoryActive[key][val].yearsId.length
                ? (this.chackoutCategoryActive[key][val].active = true)
                : (this.chackoutCategoryActive[key][val].active = false);
            }
          });
        });
      });
    },
    checkedQty() {
      let years = [];
      Object.keys(this.chackoutCategory).forEach(key => {
        let qty = 0;
        Object.keys(this.chackoutCategory[key]).forEach(val => {
          qty += this.chackoutCategory[key][val].year.length;
          this.chackoutCategory[key][val].year.forEach(y => {
            years.push(y);
          });
          this.chackoutCategoryActive[key][val].qty = this.chackoutCategory[
            key
          ][val].year.length;
        });
        this.chackoutCategoryActive[key].qty = qty;
      });
      this.form.car_year_id = years;
      this.categoryNameLisr = this.getCategoryName(this.form.car_year_id);
      this.confirmQty();
    },
    removeYearActive(id) {
      Object.keys(this.chackoutCategory).forEach(key => {
        Object.keys(this.chackoutCategory[key]).forEach(val => {
          this.chackoutCategory[key][val].year.forEach((year, index) => {
            if (id == "all") {
              this.chackoutCategory[key][val].year = [];
              return;
            }
            if (year == id) {
              this.chackoutCategory[key][val].year.splice(index, 1);
            }
          });
        });
      });
    },
    renderYearActive(categories) {
      categories.forEach(val => {
        this.chackoutCategory[val.car_brand_id][val.car_model_id].year.push(
          val.car_year_id
        );
      });
    },
    getTypeName(value) {
      switch (value) {
        case "gas":
          return "汽油車";
        case "hybrid":
          return "油電車";
        case "electric":
          return "電動車";
        case "diesel":
          return "柴油車";
      }
    },
    changeStatus(ele, id) {
      if (!document.getElementById(ele).checked) {
        Swal.fire({
          title: "更改為停用狀態",
          text: "確定要停用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "停用"
        }).then(result => {
          if (result.value) {
            Product.status(id, { status: 0 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = false;
                  this.getProduct();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = true;
                }
              })
              .catch(err => {
                console.error(err);
                document.getElementById(ele).checked = true;
              });
          } else {
            document.getElementById(ele).checked = true;
          }
        });
      } else {
        Swal.fire({
          title: "更改為啟用狀態",
          text: "確定要啟用嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "取消",
          confirmButtonText: "啟用"
        }).then(result => {
          if (result.value) {
            Product.status(id, { status: 1 }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  Toast.fire({
                    icon: "success",
                    title: "修改成功"
                  });
                  document.getElementById(ele).checked = true;
                  this.getProduct();
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "修改失敗",
                    text: res.data.error
                  });
                  document.getElementById(ele).checked = false;
                }
              })
              .catch(err => {
                console.error(err);
                document.getElementById(ele).checked = false;
              });
          } else {
            document.getElementById(ele).checked = false;
          }
        });
      }
    },
    resetForm() {
      this.modal_title = "新增商品";
      this.isEdit = false;
      this.edit_id = null;
      this.formValidity = true;

      this.state.name = null;
      this.state.serial_no = null;
      this.state.price = null;
      this.state.car_year_id = null;
      this.state.part_category_id = null;
      this.state.part_brand_id = null;

      this.form.name = "";
      this.form.serial_no = "";
      this.form.price = "";
      this.form.description = "";
      this.form.car_year_id = [];
      this.form.part_category_id = "";
      this.form.part_brand_id = "";
      this.form.images = [];
      this.form.general_parts = 0;

      this.brand_active.id = null;
      this.brand_active.name = null;
      this.model_active = null;
      this.type_active = null;
      this.removeYearActive("all");
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.form.name ? (this.state.name = null) : (this.state.name = false);
      this.form.serial_no
        ? (this.state.serial_no = null)
        : (this.state.serial_no = false);
      this.form.part_category_id
        ? (this.state.part_category_id = null)
        : (this.state.part_category_id = false);
      this.form.part_brand_id
        ? (this.state.part_brand_id = null)
        : (this.state.part_brand_id = false);
      this.form.price ? (this.state.price = null) : (this.state.price = false);
      !this.form.general_parts && this.form.car_year_id
        ? (this.state.car_year_id = null)
        : (this.state.car_year_id = false);
      if (this.form.general_parts) {
        this.state.car_year_id = null;
      } else {
        this.form.car_year_id.length
          ? (this.state.car_year_id = null)
          : (this.state.car_year_id = false);
      }
    },
    edit(id) {
      this.resetForm();
      this.isEdit = true;
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalVendorModal", "#btnShow");
    },
    copy(id) {
      this.resetForm();
      this.edit_id = id;
      this.$root.$emit("bv::show::modal", "modalVendorModal", "#btnShow");
    },
    showModal() {
      this.formValidity = true;
      this.isModalShow = true;
      if (this.isEdit) {
        this.modal_title = "編輯商品";
        Product.get(this.edit_id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.form.name = res.data.name;
              this.form.serial_no = res.data.serial_no;
              this.form.price = res.data.price;
              this.form.description = res.data.description;
              this.form.part_category_id = res.data.tag.part_category_id;
              this.form.part_brand_id = res.data.brands[0].part_brand_id;
              res.data.images.forEach(val => {
                this.form.images.push(val.image_link);
              });
              if (res.data.general_parts) {
                this.form.general_parts = res.data.general_parts;
              } else {
                res.data.categories.forEach(val => {
                  this.form.car_year_id.push(val.car_year_id);
                });
              }
              this.renderYearActive(res.data.categories);
            } else {
              Toast.fire({
                icon: "error",
                title: "取得商品資料失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else if (this.edit_id) {
        Product.get(this.edit_id, this.token)
          .then(res => {
            if (res.status <= 201) {
              this.form.name = res.data.name;
              this.form.price = res.data.price;
              this.form.description = res.data.description;
              this.form.part_category_id = res.data.tag.part_category_id;
              this.form.part_brand_id = res.data.brands[0].part_brand_id;
              res.data.images.forEach(val => {
                this.form.images.push(val.image_link);
              });
              if (res.data.general_parts) {
                this.form.general_parts = res.data.general_parts;
              } else {
                res.data.categories.forEach(val => {
                  this.form.car_year_id.push(val.car_year_id);
                });
              }
              this.renderYearActive(res.data.categories);
            } else {
              Toast.fire({
                icon: "error",
                title: "取得商品資料失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.resetForm();
      }
      this.imageError();
    },
    hiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        this.formValidity = false;
        return;
      }
      for (const value of Object.keys(this.state)) {
        if (this.state[value] === false) {
          this.formValidity = false;
          return;
        }
      }
      let newData = Object.assign({}, this.form);
      // images[]['image_link']="/xxx"&images[]['image_link']="/xxx"
      newData.images = this.form.images.map(val => {
        return {
          image_link: val
        };
      });
      if (this.isEdit) {
        Product.update(this.edit_id, newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.getProduct();
              this.$root.$emit(
                "bv::hide::modal",
                "modalVendorModal",
                "#btnShow"
              );
            } else {
              Toast.fire({
                icon: "error",
                title: "編輯失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        Product.create(newData, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "新增成功"
              });
              this.$root.$emit(
                "bv::hide::modal",
                "modalVendorModal",
                "#btnShow"
              );
              this.getProduct();
            } else {
              Toast.fire({
                icon: "error",
                title: "新增失敗",
                text: res.data.error
              });
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    reportWindowSize() {
      const windowWidth = window.innerWidth;
      if (windowWidth < 992) {
        this.isLayoutToLg = true;
      } else {
        this.isLayoutToLg = false;
      }
    },
    dele(id) {
      Swal.fire({
        title: "確定要刪除？",
        text: "請注意，刪除後商品將無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Product.delete(id, this.token)
            .then(res => {
              if (res.status <= 201) {
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
                this.getProduct();
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },
  mounted() {
    this.reportWindowSize();
    window.addEventListener("resize", this.reportWindowSize);
  }
};
</script>
